import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Bootstrap
} from '../../components';
import {
  Header,
  Footer
} from '../../containers';
import {
  fetchPostsIfNeeded,
  invalidateSubreddit,
  selectSubreddit
} from '../../actions';
import Picker from './Picker';
import Posts from './Posts';

class AsyncApp extends React.Component { 
  constructor(props) { 
    super(props)
    this.handleChange = this.handleChange.bind(this) 
    this.handleRefreshClick = this.handleRefreshClick.bind(this) 
  }

  componentDidMount() { 
    const { dispatch, selectedSubreddit } = this.props 
    dispatch(fetchPostsIfNeeded(selectedSubreddit)) 
  }

  componentDidUpdate(prevProps) { 
    if (this.props.selectedSubreddit !== prevProps.selectedSubreddit) { 
      const { dispatch, selectedSubreddit } = this.props 
      dispatch(fetchPostsIfNeeded(selectedSubreddit)) 
    } 
  }

  handleChange(nextSubreddit) { 
    this.props.dispatch(selectSubreddit(nextSubreddit)) 
    this.props.dispatch(fetchPostsIfNeeded(nextSubreddit)) 
  }

  handleRefreshClick(e) { 
    e.preventDefault() 
    const { dispatch, selectedSubreddit } = this.props 
    dispatch(invalidateSubreddit(selectedSubreddit)) 
    dispatch(fetchPostsIfNeeded(selectedSubreddit)) 
  }

  render() { 
    const { selectedSubreddit, posts, isFetching, lastUpdated } = this.props 
    return ( 
      <div> 
        <Header />
        <Bootstrap.Container>
        <Picker value={selectedSubreddit} 
          onChange={this.handleChange} 
          options={[ 'erps', 'reactjs', 'frontend', 'map' ]} 
        /> 
        <p>
          {lastUpdated && 
            <span> 
              Last updated at {new Date(lastUpdated).toLocaleTimeString()}. 
              {' '} 
            </span> 
          } 
          {!isFetching && 
            <a href='./' onClick={this.handleRefreshClick}> 
              Refresh 
            </a> 
          } 
        </p> 
        {isFetching && posts.length === 0 && <h2>Loading...</h2>} 
        {!isFetching && posts.length === 0 && <h2>Empty.</h2>} 
        {posts.length > 0 && 
          <div style={{ opacity: isFetching ? 0.5 : 1 }}> 
            <Posts posts={posts} />
          </div> 
        } 
        </Bootstrap.Container>
        <Footer />
      </div>
    )
  }
}

AsyncApp.propTypes = { 
  selectedSubreddit: PropTypes.string.isRequired, 
  posts: PropTypes.array.isRequired, 
  isFetching: PropTypes.bool.isRequired, 
  lastUpdated: PropTypes.number, 
  dispatch: PropTypes.func.isRequired 
}

function mapStateToProps(state) { 
  const { selectedSubreddit, postsBySubreddit } = state 
  const { 
    isFetching, 
    lastUpdated, 
    items: posts 
  } = postsBySubreddit[selectedSubreddit] || { 
    isFetching: true, 
    items: [] 
  } 

  return { 
    selectedSubreddit, 
    posts, 
    isFetching, 
    lastUpdated 
  }
}

export default connect(mapStateToProps)(AsyncApp)



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/subreddit/index.js